module.exports = __webpack_public_path__ + "img/teacher.1837a5d9.svg";